:host {
  display: block;
  position: relative;
}

.customer-edit {
  display: grid;
  gap: 0.75em;
}
